export const playingBar = {
  'Now playing view': 'Now playing view',
  Lyrics: 'Lyrics',
  Queue: 'Queue',
  'Connect to a device': 'Connect to a device',
  Mute: 'Mute',
  Unmute: 'Unmute',
  'Full Screen': 'Full Screen',
  'Now playing': 'Now playing',
  Next: 'Next',
  Skills: 'Skills',
  Experience: 'Experience',
  Description: 'Description',
  Images: 'Images',
  'Related projects': 'Related projects',
  'Exit full screen': 'Salir de pantalla completa',
};
